import { render, staticRenderFns } from "./NlpWhoIsForLinesTablet.vue?vue&type=template&id=0482be73"
import script from "./NlpWhoIsForLinesTablet.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsForLinesTablet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports